import { render, staticRenderFns } from "./MaterialRecords.vue?vue&type=template&id=491ed8d6&scoped=true"
import script from "./MaterialRecords.vue?vue&type=script&lang=js"
export * from "./MaterialRecords.vue?vue&type=script&lang=js"
import style0 from "./MaterialRecords.vue?vue&type=style&index=0&id=491ed8d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491ed8d6",
  null
  
)

export default component.exports